export default __webpack_public_path__ + "static/media/dr-monisha.5d92df72.jpg";